import axios from "axios";
import { CONFIG } from "../config";
import { getHeaders } from "../api/getHeaders";
import { getLogoutCallback } from "../auth/logoutHandler";
import { snackbarUtils } from "../utils";

// Create axios instance with base configuration
const api = axios.create({
  baseURL: CONFIG.API_URL,
});

// Request interceptor to add headers
api.interceptors.request.use(
  async (config) => {
    try {
      const headers = await getHeaders();
      if (headers) {
        config.headers = { ...config.headers, ...headers };
      } else {
        // Fallback headers
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        };
      }
    } catch (error) {
      console.error("Error getting headers:", error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
const ADMIN_REQUIRED_MESSAGE = "Admin access required";

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const detail =
      error.response?.data?.detail ?? error.response?.data?.message ?? "";

    if (status === 403 && String(detail).includes("Admin access required")) {
      snackbarUtils.showError?.(detail);
      const logout = getLogoutCallback();
      if (typeof logout === "function") {
        logout({ returnTo: window.location.origin });
      }
    } else {
      console.error("API Error:", error);
    }
    return Promise.reject(error);
  }
);

export { api };
